export class CustomEventCommand {
    public _id: string;
    public btnText: string;
    public sourceType: 'page' | 'location' | 'selected' | 'feed'  | 'all';
    public pageFeedId: string;
    public locationFeedId: string;
    public feedId: string;
    public isTurnOn: boolean;
    public events: string[]
}

export class CustomPlaceCommand {
    public _id: string;
    public btnText: string;
    public isTurnOn: boolean;
    public places: string[]
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/hub/custom.event.command.ts